<div class="container-fluid" #top>
    <div class="row">
        <div class="col-md-12" *ngIf="isLoading">
            <app-busy [message]="message"></app-busy>
        </div>
        <div class="tab-content" style="margin-top:20px;width:100%;">
            <div class="mk-frm" id="car-conf">
                <div class="col-12" *ngIf="carrierApproval && canload">
                    <submission [ctrlData]="ctrlData" [hideBackButton]="status == 1"></submission>
                </div>
                <div class="col-12" *ngIf="permitApproval && canload">
                    <confirmation-viewer [dataCntrl]="dataCntrl"></confirmation-viewer>
                </div>
                <div class="col-12" *ngIf="complianceApproval && canload">
                    <app-viewannualcompliance [ctrlData]="ctrlData"></app-viewannualcompliance>
                </div>
                <br>
                <div class="under-line"></div>
                <div class="col-12" *ngIf="canload">
                    <app-process [dataCntrl]="dataCntrl"></app-process>
                </div>
            </div>
        </div>

        
    </div>
</div>